import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

type MainContentWrapperTypes = {
	reverse?: boolean;
};
export const MainContentWrapper = styled.div<MainContentWrapperTypes>`
	max-width: 1484px;
	margin: 0 auto;
	display: flex;
	flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
	padding: 144px 84px;
	gap: 144px;

	${media.belowLarge`
		flex-direction: column;
		gap: 24px;
		padding: 48px 24px;
	`}
`;

export const MainContentColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	flex: 1;
	gap: 32px;
	position: relative;

	${media.belowLarge`
		align-items: center;
	`}
`;

export const Content = styled.p`
	font-size: 1.6rem;
	line-height: 2.4rem;
	white-space: pre-line;
	margin: 0;
	width: 528px;

	${media.belowLarge`
		width: unset;	
	`};
`;

export const Title = styled.h2`
	font-size: 4.8rem;
	line-height: 5.6rem;
	color: #131315;
	text-align: left;
`;

export const ShapeWrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: -1;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;

	${media.belowLarge`
		margin: 0 24px;
	`}
`;
